<template>
  <div class="accordeon__item checked" :class="{active : isOpen}">
    <div class="accordeon__item-top" @click="toggleView">
      <span class="accordeon__item-name">{{ stageData.name }}</span>
      <span class="accordeon__item-toggle"></span>
      <span class="accordeon__item-popup" data-fancybox-accordeon :href="`#${stageData.code}-accordeon`"></span>
    </div>
    <div class="accordeon__item-content fancy-dropdow" :id="`${stageData.code}-accordeon`">
      <div class="accordeon__item-close fancy-dropdow__close"></div>
      <div class="accordeon__item-body fancy-dropdown__cont">
        <span class="accordeon__item-title">{{ stageData.name }}</span>
        <div class="individual-packing__options-list">

          <template v-for="group in stageData.groups" :key="group.code">
            <template v-if="getFieldsGroupVisibility(group.code)">
              <div v-for="field in group.fields" :key="field.id" class="individual-packing__options-el">
                <span class="individual-packing__options-name">{{ field.name }}</span>

                <template v-if="field.type === 'file'">
                  <div v-if="getFormValueByKey(field.code) && getFormValueByKey(field.code).length"
                       class="individual-packing__photo">
                    <div class="preview__item"
                         v-for="file in getFormValueByKey(field.code)"
                         :key="file.name"
                         :title="file.name"
                    >
                      <div class="preview__item-img"
                           :class="{'preview__item-img--file' : !getFileData(file).isImage}"
                           :data-ext="getFileData(file).ext"
                           :style="getFileData(file).isImage ? `background-image : url(${getFileData(file).url})` : ''"
                      ></div>
                    </div>
                  </div>
                  <div v-else class="individual-packing__options-text">—</div>
                </template>

                <template v-else-if="shouldSpecifyValue(field.type)">
                  <template v-if="Array.isArray(getFormValueByKey(field.code))">
                    <div v-if="!getFormValueByKey(field.code).length" class="individual-packing__options-text">—</div>
                    <div v-else v-for="val in getFormValueByKey(field.code)" :key="val"
                         class="individual-packing__options-text">{{ getSpecifiedValue(field, val) || '—' }}
                    </div>
                  </template>
                  <div v-else class="individual-packing__options-text">
                    {{ getSpecifiedValue(field, getFormValueByKey(field.code)) || '—' }}
                  </div>
                </template>

                <div v-else class="individual-packing__options-text">{{ getFormValueByKey(field.code) || '—' }}</div>

              </div>
            </template>
          </template>
        </div>
        <div class="individual-packing__options-edit">
          <button class="icon-link icon-link--base" data-fancybox-close
                  @click.prevent="$parent.$emit('editStage', stageData.code)">
            <span>{{ changeTitle }}</span>
            <svg class="icon-link__icon" aria-hidden="true">
              <use xlink:href="/local/templates/xpage/img/icons/icons.svg#svg-edit"></use>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getFileData} from "@/mixins/fileData";
import {useIndividualPacking} from "@/hooks/useIndividualPacking";
import {IPFieldsView} from "@/mixins/IPFieldsView";

export default {
  name: "IPFinalOption",
  mixins: [getFileData, useIndividualPacking, IPFieldsView],
  props: {
    stageData: {
      type: Object,
      required: true,
      default: () => ({
        code: '',
        groups: [],
        id: null,
        name: '',
        sort: 10,
      })
    },
    isOpenDefault: {
      type: Boolean,
      default: false,
    },
    changeTitle: {
      type: [String],
      default: BX.message('CATALOG_INDIVIDUAL_OPTION')
    },
  },
  data() {
    return {
      isOpen: false,
    }
  },
  created() {
    this.isOpen = this.isOpenDefault;
  },
  computed: {
    shouldSpecifyValue() {
      return (fieldType) => {
        switch (fieldType) {
          case 'checkbox':
          case 'radio':
          case 'select':
          case 'switch':
            return true;

          default:
            return false;
        }

      }
    },
    getSpecifiedValue() {
      return (field, fieldVal) => {
        const options = field.enum || [];
        return options.find(option => option.id === fieldVal)?.name || '';
      }
    }
  },
  methods: {
    toggleView() {
      if (window.matchMedia('(min-width: 30em)').matches) this.isOpen = !this.isOpen;
    }
  }
}
</script>

<style scoped>

</style>